import { FETCH_PIXEL_SETS, CREATE_PIXEL_SET, UPDATE_PIXEL_SET, DESTROY_PIXEL_SET, LOGOUT } from '../actions/actionTypes.js';
import { keyBy, omit } from 'lodash';

const initialState = {}

export const pixelSets = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PIXEL_SETS.SUCCESS:
      return keyBy(action.payload['pixel_sets'] || [], 'id');
    case FETCH_PIXEL_SETS.UNLOAD:
      return {};
    case CREATE_PIXEL_SET.SUCCESS:
    case UPDATE_PIXEL_SET.SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload
      };
    case DESTROY_PIXEL_SET.SUCCESS:
      return omit(state, action.payload.id);
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pixelSets.js